import { Injectable } from '@angular/core';
import { TableSort } from '../../collection/models/table-sort';
import { TableSortOrderType } from '../../collection/enums/table-sort-order-type';
import { CollectionSortRequest } from '../requests/collection-sort.request';
import { CollectionSortOrder } from '../enums/collection-sort-order';
import { isNil, Nillable } from '@web/utils';
import { RequiredMethodCallException } from '../../exceptions/required-method-call.exception';

@Injectable({
  providedIn: 'root',
})
export class CollectionSortRequestBuilder {
  private _property: Nillable<string>;
  private _order: Nillable<CollectionSortOrder>;

  public newInstance(): CollectionSortRequestBuilder {
    return new CollectionSortRequestBuilder();
  }

  public reset(): this {
    return this;
  }

  public fromTableSort(sort: Nillable<TableSort>): this {
    if (isNil(sort)) {
      return this;
    }

    const { field, order } = sort;
    const collectionOrder =
      order === TableSortOrderType.Ascending
        ? CollectionSortOrder.Ascending
        : CollectionSortOrder.Descending;

    return this.property(field).order(collectionOrder);
  }

  public property(property: string): this {
    this._property = property;

    return this;
  }

  public ascendingFor(property: string): this {
    return this.property(property).order(CollectionSortOrder.Ascending);
  }

  public descendingFor(property: string): this {
    return this.property(property).order(CollectionSortOrder.Descending);
  }

  public order(order: CollectionSortOrder): this {
    this._order = order;

    return this;
  }

  public buildAsArray(): CollectionSortRequest[] {
    if (isNil(this._property) || isNil(this._order)) {
      return [];
    }
    return [this.build()];
  }

  public build(): CollectionSortRequest {
    this.requireProperty();
    this.requireOrder();

    return new CollectionSortRequest(this._property!, this._order!);
  }

  private requireProperty(): void {
    if (isNil(this._property)) {
      throw new RequiredMethodCallException(this.property.name);
    }
  }

  private requireOrder(): void {
    if (isNil(this._order)) {
      throw new RequiredMethodCallException(this.order.name);
    }
  }
}
